import { Components } from '@mui/material';
import {
  button,
  table,
  form,
  pagination,
  breadscrumbs,
  accordion,
  input,
  badge,
  dialog,
} from './componentOverrides';
import { checkbox } from './checkbox';

export const components: Components = {
  ...button,
  ...form,
  ...table,
  ...breadscrumbs,
  ...pagination,
  ...accordion,
  ...input,
  ...badge,
  ...dialog,
  ...checkbox,
};
